import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

const WIDTH = 72;
const HEIGHT = 28;
const PADDING = 2;

const TREND_COLORS = {
  up: "#137333",
  down: "#a50e0e",
  stable: "#9aa0a6",
};

const buildPolylinePoints = (values = []) => {
  if (values.length < 2) {
    return "";
  }

  const numeric = values.map((v) => Number(v) || 0);
  const min = Math.min(...numeric);
  const max = Math.max(...numeric);
  const range = max - min || 1;
  const innerWidth = WIDTH - PADDING * 2;
  const innerHeight = HEIGHT - PADDING * 2;

  return numeric
    .map((value, index) => {
      const x = PADDING + (index / (numeric.length - 1)) * innerWidth;
      const y = PADDING + innerHeight - ((value - min) / range) * innerHeight;
      return `${x},${y}`;
    })
    .join(" ");
};

const MetricSparkline = ({
  values = [],
  trend = "stable",
  isLoading = false,
  width = WIDTH,
  height = HEIGHT,
}) => {
  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        width={width}
        height={height}
        sx={{ flexShrink: 0 }}
      />
    );
  }

  if (!values || values.length < 2) {
    return (
      <Box
        sx={{
          width,
          height,
          flexShrink: 0,
        }}
      />
    );
  }

  const points = buildPolylinePoints(values);
  const pointList = points.split(" ").filter(Boolean);
  const lastPoint = pointList[pointList.length - 1] || "";
  const [lastX, lastY] = lastPoint.split(",").map(Number);
  const strokeColor = TREND_COLORS[trend] || TREND_COLORS.stable;

  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      sx={{ flexShrink: 0, display: "block" }}
      aria-hidden
    >
      <polyline
        fill="none"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
      {!Number.isNaN(lastX) && !Number.isNaN(lastY) && (
        <circle cx={lastX} cy={lastY} r="2.5" fill={strokeColor} />
      )}
    </Box>
  );
};

export default MetricSparkline;
